import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { ANON_USER } from '../../config/text/text';
import { formatShortDate } from '../../helpers/date';
import ThemeContext from '../../providers/ThemeProvider';
import Stars from '../_generic/stars/Stars';

const MainDealReviewItem = ({ review, hidden, className }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className={classNames('review', className)} hidden={hidden}>
        <p className="review__author">{review.nameLocation || ANON_USER}</p>
        <div className="review__meta">
          <p className="review__date">{formatShortDate(review.date)}</p>
          <Stars value={review.rating} />
        </div>
        <p className="review__text">{review.review}</p>
      </div>

      <style jsx>{`
        .review {
          margin-bottom: 12px;
        }
        .review__author {
          color: ${theme.colors.primary};
          margin: 0 0 2px 0;
        }
        .review__meta {
          display: flex;
          align-items: center;
          font-size: 12px;
          margin-bottom: 10px;
        }
        .review__date {
          margin: 0 8px 0 0;
          line-height: 1em;
        }
      `}</style>
    </>
  );
};

MainDealReviewItem.propTypes = {
  className: PropTypes.string,
  hidden: PropTypes.bool,
  review: PropTypes.object,
};

MainDealReviewItem.defaultProps = {
  className: '',
  hidden: false,
  review: {},
};

export default MainDealReviewItem;
